import {BeforeYouthPlayerRecruitmentEvent} from "@/modules/youth/event/BeforeYouthPlayerRecruitmentEvent";

export class AfterYouthPlayerTransferEvent extends BeforeYouthPlayerRecruitmentEvent {
}